// จัดการรูปโลโก้ของกลุ่มสินค้า

/** โลโก้สินค้าบางตัวใน Wazzup ใช้ไม่ได้ (404) — ต้องลองโหลดจริงก่อนเอาไปใช้ */
export function imageLoads(url?: string | null): Promise<boolean> {
  return new Promise((resolve) => {
    if (!url) return resolve(false);
    const img = new Image();
    img.onload = () => resolve(img.naturalWidth > 0);
    img.onerror = () => resolve(false);
    img.src = url;
  });
}

/** รูปกลุ่มอัตโนมัติ = โลโก้ของสมาชิกตัวแรกที่โหลดได้ (เรียงตามลำดับสมาชิก) */
export async function autoGroupLogo(urls: (string | undefined)[]): Promise<string | null> {
  const candidates = urls.filter((u): u is string => !!u);
  const results = await Promise.all(candidates.map(imageLoads));
  const i = results.findIndex(Boolean);
  return i >= 0 ? candidates[i] : null;
}

/** ย่อรูปที่อัปโหลดให้เล็กก่อนเก็บเป็น data URI (คงความโปร่งใสไว้ถ้าเป็น PNG) */
export function fileToLogoDataUrl(file: File, max = 256): Promise<string> {
  return new Promise((resolve, reject) => {
    if (!file.type.startsWith("image/")) return reject(new Error("ไฟล์นี้ไม่ใช่รูปภาพ"));
    const fr = new FileReader();
    fr.onerror = () => reject(new Error("อ่านไฟล์ไม่สำเร็จ"));
    fr.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error("ไฟล์รูปเสียหาย"));
      img.onload = () => {
        const scale = Math.min(1, max / Math.max(img.width, img.height));
        const w = Math.max(1, Math.round(img.width * scale));
        const h = Math.max(1, Math.round(img.height * scale));
        const canvas = document.createElement("canvas");
        canvas.width = w;
        canvas.height = h;
        canvas.getContext("2d")?.drawImage(img, 0, 0, w, h);
        const out =
          file.type === "image/png"
            ? canvas.toDataURL("image/png")
            : canvas.toDataURL("image/jpeg", 0.9);
        if (out.length > 1_500_000) return reject(new Error("รูปใหญ่เกินไป ลองรูปที่เล็กกว่านี้"));
        resolve(out);
      };
      img.src = String(fr.result);
    };
    fr.readAsDataURL(file);
  });
}
